import {
  u2000CurrentWeekMondayYmd,
  u2000MondayOfCivilWeekYmd,
  u2000PreviousWeekMondayYmd,
  u2000ShiftCivilYmd,
  u2000TodayOrgYmd,
} from "../../u2000Core/tools/U2000DateTimeHelpers";

/** Préréglage de période pour la liste U3129 (recherche). */
export type U3129PeriodPreset = "current_week" | "previous_week" | "all_weeks";

/** @deprecated Préférer u2000CurrentWeekMondayYmd */
export function getMondayOfWeek(): Date {
  const mondayYmd = u2000CurrentWeekMondayYmd();
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(mondayYmd);
  if (!m) return new Date();
  return new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
}

/** @deprecated Préférer u2000CurrentWeekMondayYmd */
export function getMondayIsoLocal(monday: Date): string {
  const y = monday.getUTCFullYear();
  const mo = String(monday.getUTCMonth() + 1).padStart(2, "0");
  const day = String(monday.getUTCDate()).padStart(2, "0");
  return `${y}-${mo}-${day}`;
}

/** Lundi de la semaine courante (jour civil org). */
export function getCurrentWeekMondayIsoLocal(): string {
  return u2000CurrentWeekMondayYmd();
}

/** Lundi de la semaine précédente (jour civil org). */
export function getPreviousWeekMondayIsoLocal(): string {
  return u2000PreviousWeekMondayYmd();
}

/** Lundi de la semaine civile contenant aujourd'hui (org). */
export function u3129MondayOfOrgWeekYmd(ymd?: string): string {
  const base = ymd?.trim() ? u2000MondayOfCivilWeekYmd(ymd) : u2000CurrentWeekMondayYmd();
  return base ?? u2000TodayOrgYmd();
}

/** Décale un lundi civil de `weekOffset` semaines. */
export function u3129ShiftMondayYmd(mondayYmd: string, weekOffset: number): string | null {
  return u2000ShiftCivilYmd(mondayYmd, weekOffset * 7);
}
